import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import classNames from 'classnames';
import { Constants } from '@praktio/common';

// Ducks
import { RootState } from '../../../ducks/configureStore';
import { update as updateQuiz } from '../../../ducks/quizLitmosReducer';
import { WindowSizes } from '../../../utils/constants';
import { ConditionalTooltip } from '@praktio/common-ui';

const { CataTypes } = Constants;

interface InfoPillTooltipProps {
  activityComplete?: boolean;
  quizLitmos: Quiz;
  tooltipText?: string;
  windowSize: string;
}

const InfoPillTooltip = ({
  activityComplete,
  quizLitmos,
  tooltipText,
  windowSize,
}: InfoPillTooltipProps) => {
  const dispatch = useDispatch();
  return (
    <ConditionalTooltip
      ignoreTooltip={!tooltipText || tooltipText.length === 0}
      overlayPopoverId="InfoPill-tooltip"
      overlayTriggerPlacement="auto"
      tooltipText={tooltipText}
      triggerAction={['hover', 'click']}
    >
      <div
        className={classNames('InfoPill-tooltip', windowSize)}
        onMouseEnter={() => {
          if (!activityComplete) {
            dispatch(
              updateQuiz({
                ...quizLitmos,
                choicesShouldPulse: true,
              }),
            );
          } else {
            dispatch(
              updateQuiz({
                ...quizLitmos,
                explanationButtonsShouldPulse: true,
              }),
            );
          }
        }}
        onMouseLeave={() => {
          dispatch(
            updateQuiz({
              choicesShouldPulse: false,
              explanationButtonsShouldPulse: false,
            }),
          );
        }}
      >
        <span className="material-icons-outlined">help_outline</span>
      </div>
    </ConditionalTooltip>
  );
};

interface IProps {
  instructions: string;
  tooltipText: string;
  activityComplete: boolean;
  layoutIsHorizontal: boolean;
  feedbackPanelWidth?: number;
  windowSize: string;
}

const InfoPill = ({
  instructions,
  tooltipText,
  activityComplete,
  layoutIsHorizontal,
  feedbackPanelWidth,
  windowSize,
}: IProps) => {
  // Redux State
  const { quizLitmos, slideSubType } = useSelector((state: RootState) => {
    const { quizLitmos, slidesLitmos } = state;
    const { tooltipEngaged, tooltipVisible } = quizLitmos;
    const { currentSlide } = slidesLitmos;
    const { subType: slideSubType } = currentSlide || {};
    return {
      tooltipEngaged,
      tooltipVisible,
      quizLitmos,
      slideSubType,
    };
  });

  const arrowPresent =
    (slideSubType !== CataTypes.EditHorizontal || activityComplete) &&
    windowSize !== WindowSizes.Small;

  return (
    <div
      className={classNames('InfoPill', windowSize, {
        'horizontal-layout': layoutIsHorizontal,
      })}
      style={{ width: feedbackPanelWidth && activityComplete ? feedbackPanelWidth + 42 : '' }}
    >
      {arrowPresent && (
        <div className="InfoPill-arrow d-none d-md-flex">
          <span className="material-icons">arrow_downward</span>
        </div>
      )}
      <div className={classNames('InfoPill-text', { arrowPresent })}>{instructions}</div>

      <InfoPillTooltip
        activityComplete={activityComplete}
        quizLitmos={quizLitmos}
        tooltipText={tooltipText}
        windowSize={windowSize}
      />
    </div>
  );
};

export default InfoPill;
